import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { toast } from "react-toastify";

//  SSO LOGIN THUNK
export const ssoLogin = createAsyncThunk(
  "auth/ssoLogin",
  async (idToken, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/auth/sso", {
        token: idToken,
      });

      console.log("SSO FULL RESPONSE:", response);

      //  Extract token from headers
      const authHeader = response.headers["authorization"];

      let token = null;

      if (authHeader?.startsWith("Bearer ")) {
        token = authHeader.split(" ")[1];
      }

      if (!token) {
        throw new Error("Token not found in response");
      }

      //  Store in sessionStorage
      sessionStorage.setItem("token", token);

      toast.success("Login successful");

      return {
        token,
        user: response.data,
      };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "SSO Login failed";

      toast.error(message);

      return rejectWithValue(message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: sessionStorage.getItem("token") || null,
    isAuthenticated: !!sessionStorage.getItem("token"),
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;

      sessionStorage.removeItem("token");

      toast.info("Logged out successfully 👋");
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 LOGIN
      .addCase(ssoLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ssoLogin.fulfilled, (state, action) => {
        state.loading = false;

        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAuthenticated = true;
      })
      .addCase(ssoLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;